import { useMemo } from "react";
import pickBy from "lodash/pickBy";

const filterDataAttributes = (props) => {
  return pickBy(props, (_value, key) => key.startsWith("data-"));
};

/**
 * @template {Record<string, any>} T
 *
 * @param {T} props
 * @returns {Partial<T>?} - Returns a partial object with only the data attributes
 */
const useDataAttributes = (props) => {
  return useMemo(() => filterDataAttributes(props || {}), [props]);
};

export default useDataAttributes;
